import { handleActions } from 'redux-actions';
import { defaultBrowsingModeWidgetState } from './defaults';
import { BrowsingModeWidgetData } from './types';
import { initBrowsingPage } from '../../actions';
import {
  makeSpecificSaveableWidgetDataMergeFunction,
  saveRequestMetaReducer,
} from '../utils';
import {
  setBrowsingModeWidgetContentFilter,
  saveBrowsingMode,
  saveBrowsingModeSuccess,
  saveBrowsingModeFailure,
} from './actions';
import { NetworkRequestState } from '../baseTypes';

const mergeBrowsingModeWidgetDataChange =
  makeSpecificSaveableWidgetDataMergeFunction(defaultBrowsingModeWidgetState);

export default handleActions<BrowsingModeWidgetData, any>(
  {
    [initBrowsingPage.toString()]: (
      state,
      action: ReturnType<typeof initBrowsingPage>
    ) => {
      const data: BrowsingModeWidgetData['initialData'] = {
        contentFilter: action.payload.data.contentFilter,
        contentFilterList: action.payload.data.contentFilterList,
      };
      return {
        initialData: data,
        currentData: data,
        isDirty: false,
        saveRequest: {
          status: NetworkRequestState.IDLE,
        },
      };
    },
    [setBrowsingModeWidgetContentFilter.toString()]: (
      state,
      action: ReturnType<typeof setBrowsingModeWidgetContentFilter>
    ) =>
      mergeBrowsingModeWidgetDataChange(state, {
        contentFilter: action.payload.contentFilter as
          | 'standard'
          | 'mature'
          | 'safe',
      }),
    ...saveRequestMetaReducer({
      initialAction: saveBrowsingMode,
      successAction: saveBrowsingModeSuccess,
      failureAction: saveBrowsingModeFailure,
    }),
  },
  defaultBrowsingModeWidgetState
);
